<template>
  <div
    class="calendar-dialog-component"
    :class="showPage ? 'active' : ''"
    @click="hide"
  >
    <div class="component-bg" :class="activePage ? 'active' : ''">
      <div class="dialog-main-area" @click.stop="expandType = false">
        <el-scrollbar class="plan-scroll">
          <div class="dialog-content">
            <div class="component-title">
              <label>时间选择</label>
              <!-- <scp-icon class="close-btn" type="fork" @click="hide"></scp-icon> -->
              <i
                class="iconfont-lunan icon-lunan-ziyuanldpi close-btn"
                @click="hide"
              ></i>
            </div>
            <div class="component-content">
              <div class="component-area">
                <div class="input-arae">
                  <el-select
                    :disabled="readOnly"
                    v-model="dateData.rangType"
                    placeholder="请选择"
                    @change="chooseType()"
                  >
                    <el-option
                      v-for="item in rangTypeMap"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <div class="date-range">
                    <el-date-picker
                      :disabled="readOnly"
                      v-model="dateRange"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      @change="chooseDate"
                      :picker-options="pickerOptions"
                    ></el-date-picker>
                  </div>
                </div>
                <div class="time-progress-area">
                  <time-progress
                    @choosed="choosedTimeRange"
                    ref="timeProgress"
                  ></time-progress>
                </div>
              </div>
            </div>
            <div class="component-footer">
              <div></div>
              <div class="btn-area">
                <el-button @click="cancelForm" type="info">{{
                  readOnly ? "关闭" : "取消"
                }}</el-button>
                <el-button v-if="!readOnly" @click="submitForm" type="primary"
                  >确定</el-button
                >
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>
<script>
import TimeProgress from "./time-progress-component";
// 时间选择范围最大值
const maxDiff = 9999;
export default {
  name: "CalendarComponent",
  components: {
    TimeProgress,
  },
  props: {},
  data() {
    return {
      options: {
        type: "day",
        oprate: {
          display: false,
        },
      },
      readOnly: false,
      showPage: false,
      activePage: false,
      rangTypeMap: [
        {
          label: "全天时段",
          value: 1,
        },
        {
          label: "自定义时段",
          value: 2,
        },
      ],
      dateRange: [],
      expandType: false,
      // 默认选中自定义时段
      // 修改自问题单：7594 【巡逻计划-创建/修改】创建/修改巡逻计划时，巡逻时间类型建议默认展示自定义时段，不要展示全天时段
      rangLabel: "自定义时段",
      dateData: {
        // 时间段类型，1-全天时段；2-自定义时段
        rangType: 2,
        startDate: "",
        endDate: "",
        plannedPlayTime: [],
      },
      firstPickDate: null,
      pickerOptions: {
        disabledDate: (time) => {
          let timeOptionRange = this.firstPickDate
            ? new Date(this.firstPickDate.toLocaleDateString())
            : null;
          let maxRange = 3600 * 1000 * 24 * maxDiff;
          if (timeOptionRange) {
            let diff =
              timeOptionRange - new Date(new Date().toLocaleDateString());
            return (
              time.getTime() > timeOptionRange.getTime() + maxRange ||
              time.getTime() <
                timeOptionRange.getTime() - (diff < maxRange ? diff : maxRange)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
        onPick: (time) => {
          if (!this.firstPickDate) {
            this.firstPickDate = time.minDate;
          }
        },
      },
    };
  },
  created() {},
  beforeDestroy() {
    document.removeEventListener("click", this.domClick);
  },
  mounted() {
    document.addEventListener("click", this.domClick);
  },
  methods: {
    domClick() {
      this.expandType = false;
    },
    show(
      dateData = {
        rangType: 2,
        startDate: "",
        endDate: "",
        plannedPlayTime: [],
      },
      readOnly = false
    ) {
      this.readOnly = readOnly;
      this.dateData = JSON.parse(JSON.stringify(dateData));
      this.dateRange = [this.dateData.startDate, this.dateData.endDate];
      this.showPage = true;
      this.activePage = true;
      let timeRangeData = [];
      this.dateData.plannedPlayTime.map((time) => {
        if (time.dayTime && time.dayTime.length) {
          time.dayTime.map((item) => {
            timeRangeData.push({
              startTime: item.startTime,
              endTime: item.endTime,
              weekNum: time.weekTime,
            });
          });
        }
      });
      const rangSetData = {
        rangType: dateData.rangType,
        startDate: dateData.startDate,
        endDate: dateData.endDate,
        dayTime: timeRangeData,
      };
      this.$log.debug("回填的时间段数据：", rangSetData);
      this.$refs.timeProgress.setDay(rangSetData, this.readOnly);
    },
    hide() {
      this.expandType = false;
      this.activePage = false;
      setTimeout(() => {
        this.showPage = false;
      }, 300);
    },
    choosedTimeRange(data = []) {
      this.dateData.plannedPlayTime = [];
      let dateTimes = {};
      data.forEach((dayTime) => {
        dateTimes[dayTime.weekNum] = dateTimes[dayTime.weekNum] || [];
        dateTimes[dayTime.weekNum].push(dayTime);
      });
      for (let key in dateTimes) {
        this.dateData.plannedPlayTime.push({
          weekTime: key,
          dayTime: dateTimes[key],
        });
      }
    },
    expandTypeSelect() {
      // 如果当前是只读设置，则不支持修改操作
      if (this.readOnly) {
        return;
      }
      this.expandType = !this.expandType;
    },
    chooseType() {
      this.$log.debug("时间段选择：", this.dateData.rangType);
      if (this.dateData.startDate && this.dateData.endDate) {
        this.dateData.plannedPlayTime = [];
        let timeRangeData = {
          rangType: this.dateData.rangType,
          startDate: this.dateData.startDate,
          endDate: this.dateData.endDate,
          dayTime: this.dateData.plannedPlayTime,
        };
        this.$refs.timeProgress.setDay(timeRangeData);
      }
    },
    cancelForm() {
      this.hide();
    },
    chooseDate() {
      if (this.dateRange && this.dateRange.length === 2) {
        this.dateData.startDate = this.dateRange[0];
        this.dateData.endDate = this.dateRange[1];
      } else {
        this.dateData.startDate = "";
        this.dateData.endDate = "";
      }
      this.firstPickDate = null;
      this.dateData.plannedPlayTime = [];
      let timeRangeData = {
        rangType: this.dateData.rangType,
        startDate: this.dateData.startDate,
        endDate: this.dateData.endDate,
        dayTime: this.dateData.plannedPlayTime,
      };
      this.$refs.timeProgress.setDay(timeRangeData);
    },
    submitForm() {
      if (!this.dateData.startDate || !this.dateData.endDate) {
        this.$message.warning("请选择日期");
        return;
      }
      if (
        !this.dateData.plannedPlayTime ||
        !this.dateData.plannedPlayTime.length
      ) {
        this.$message.warning("请选择巡逻时间段");
        return;
      }
      let result = JSON.parse(JSON.stringify(this.dateData));
      this.$emit("confirm", result);
      this.hide();
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";

.calendar-dialog-component {
  position: fixed;
  height: 0;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 105;
  font-size: 15px;

  &.active {
    height: 100%;
  }

  .pointer {
    cursor: pointer;

    * {
      cursor: pointer;
    }

    &:hover {
      color: #475892;

      * {
        color: #475892;
      }
    }
  }

  .expand-arrow {
    font-size: 14px;
    transform: rotate(0deg);
    transition: all 0.3s;

    &.little {
      font-size: 12px;
    }

    &.expand {
      transform: rotate(-180deg);
    }
  }

  .select-comp {
    padding: 0 10px;
    height: 30px;
    width: 165px;
    @include set_theme_color(background-color, page-bg-color);
    border-radius: 4px;
    border: 1px solid #313841;
    cursor: pointer;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .value-area {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      transition: all 0.3s;
      .select-transition {
        transition: all 0.3s;
      }
    }

    label {
      cursor: pointer;
    }

    &.disabled {
      cursor: no-drop;

      label {
        cursor: no-drop;
      }
    }

    .type-select {
      position: absolute;
      top: 30px;
      left: 0;
      width: 100%;
      overflow: hidden;
      height: 0;
      transition: all 0.3s;
      z-index: 101;

      .select-area {
        @include set_theme_color(background-color, page-bg-color);
        border-radius: 4px;
        border: 1px solid #313841;
        height: 100%;
        width: 100%;
      }

      .type-option {
        padding: 0 10px;

        &.choosed {
          background-color: #475892;
          color: #ffffff;
        }

        &:hover {
          background-color: #6673ac;
          color: #ffffff;
        }
      }

      &.expand {
        height: 56px;
      }
    }
  }

  .plan-scroll {
    height: 100%;
    width: 100%;

    .el-scrollbar__wrap {
      overflow-x: hidden;
    }

    .el-scrollbar__view {
      height: 100%;
    }
  }

  .hidden-item {
    visibility: hidden;
  }

  .component-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    opacity: 0;

    &.active {
      opacity: 1;
    }

    .dialog-main-area {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #ffffff;
      height: 100%;
      max-height: 450px;
      width: 870px;
      overflow: hidden;

      .dialog-content {
        height: 450px;
        width: 100%;
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .component-title {
        height: 34px;
        background-color: #303541;
        padding: 0 15px;
        color: #ffffff;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .close-btn {
          font-size: 10px;
          cursor: pointer;
          transition: all 0.3s;

          &:hover {
            transform: rotate(90deg);
          }
        }
      }

      .component-content {
        flex: 1;
        padding: 20px 25px;
        display: flex;
        justify-content: space-between;
        overflow: hidden;
        background-color: #505563;
        @include set_theme_color(color, font-active-color);

        .component-area {
          height: 100%;
          width: 100%;
          padding: 20px 0;
          display: flex;
          flex-direction: column;

          .input-arae {
            display: flex;
            margin: 0 20px;

            .date-range {
              margin-left: 20px;
              height: 30px;

              .el-input__inner {
                height: 30px;
                border-radius: 0;
                outline: none;
              }

              .el-range__icon,
              .el-range__close-icon {
                line-height: 23px;
              }

              .el-range-separator {
                line-height: 23px;
              }

              .el-range-separator {
                width: 10%;
              }
            }
          }

          .time-progress-area {
            flex: 1;
            margin-top: 20px;
            overflow: hidden;
          }
        }
      }

      .component-footer {
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 30px;
        background-color: #303541;
        .btn-area {
          display: flex;
        }

        .footer-btn {
          height: 28px;
          line-height: 28px;
          text-align: center;
          width: 80px;
          border-radius: 3px;
          cursor: pointer;
          margin-left: 20px;
          font-size: 14px;

          &:first-child {
            margin-left: 0;
          }

          &.save {
            color: #ffffff;
            background-color: #6674a6;

            &:hover {
              background-color: #5168b7;
            }

            &:active {
              background-color: #364a8e;
            }
          }

          &.cancel {
            border: 1px solid #cccccc;
            color: #333333;

            &:hover {
              background-color: #eeeeee;
            }

            &:active {
              background-color: #cccccc;
            }
          }
        }
      }
    }
  }
}
</style>
